import React from 'react';
import { useForm, useFormContext, FormProvider } from 'react-hook-form';
import { FormControl, RadioGroup, Fab } from '@material-ui/core';
import { useRecentGetter } from '@lib/common';
import { useCallback } from 'react';
import FilterIcon from '@material-ui/icons/FilterList';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file

export function FilterForm(props) {
  const {
    column: { filterValue, setFilter },
    column,
    closeFilter,
    radioFilters: RadioFilters,
  } = props;
  const form = useForm();
  const [selectedFilter, setSelectedFilter] = React.useState('');

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setSelectedFilter((event.target as HTMLInputElement).value);
    },
    [setSelectedFilter]
  );

  const formSubmit = useCallback(
    form.handleSubmit(val => {
      const toSet = {
        ...filterValue,
        ...Object.fromEntries(
          Object.entries(val).filter(([_, value]) => {
            if (value && typeof value === 'object') {
              return Array.isArray(value) ? value.filter(v => v).length : Object.keys(value).length;
            }
            return !!value;
          })
        ),
      };
      if (Object.keys(toSet).length) setFilter(toSet);
      closeFilter();
    }),
    [setFilter, closeFilter]
  );

  return (
    <FormProvider {...form}>
      <form onSubmit={formSubmit}>
        <FormControl>
          <RadioGroup value={selectedFilter} onChange={handleChange}>
            <RadioFilters
              column={column}
              setRadioFilter={setSelectedFilter}
              radioValue={selectedFilter}
              {...props}
            />
          </RadioGroup>
        </FormControl>
        <Fab color="primary" size="small" type="submit">
          <FilterIcon />
        </Fab>
      </form>
    </FormProvider>
  );
}

export function useFilterFormActions(radioValue, setRadioFilter) {
  const form = useFormContext();
  const getRadioValue = useRecentGetter(radioValue);
  const getRadioFilterSetter = useRecentGetter(setRadioFilter);

  const handleInputClick = useCallback((event: React.MouseEvent<HTMLInputElement>) => {
    const input = event.target as HTMLInputElement;
    if (getRadioValue() !== input.name) {
      getRadioFilterSetter()(input.name);
      setTimeout(() => input.focus());
    }
  }, []);

  return { handleInputClick, form, getRadioValue, getRadioFilterSetter };
}
